import { useEffect, useState } from "react"
import { simpleGetter } from "../actions/common"
import { demeritsApi, userApi } from "../api/api"

export const useDisciplinaryCases = (triggerFetch) => {
    const [data, setData] = useState([])

    const fetchData = async () => {
        const response = await simpleGetter(demeritsApi.getDisciplinaryCases)
        if (response.list) {
            setData(response.list)
        }
    }

    useEffect(() => {
        fetchData();
    }, [triggerFetch])

    return data;
}

export const useDisciplinaryHearings = (triggerFetch) => {
    const [data, setData] = useState([])

    const fetchData = async () => {
        const response = await simpleGetter(demeritsApi.getDisciplinaryHearings)
        if (response.list) {
            setData(response.list)
        }
    }

    useEffect(() => {
        fetchData();
    }, [triggerFetch])

    return data;
}

export const useUsersWithDemerits = (triggerFetch, postUpdate) => {
    const [data, setData] = useState([])

    const fetchData = async () => {
        const response = await simpleGetter(userApi.getUsersWithDemerits)
        if (response.list) {
            setData(response.list)
            if (postUpdate) {
                postUpdate(response.list);
            }
        }
    }

    useEffect(() => {
        fetchData();
    }, [triggerFetch])

    return data;
}